import axios from "axios";
import { API_ENDPOINTS } from "../Utils/ApiEndPoints";
import axiosInstance from "../Utils/axiosInstance";
class LoginService {
  static async login(loginRequest) {
    try {
      const loginUrl = API_ENDPOINTS.getLogin();
      const response = await axios.post(loginUrl, loginRequest, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error occurred during login:", error);

      // Return a consistent error object to handle in caller
      return {
        statusCode: "500",
        error: error.code || "UNKNOWN_ERROR",
        message: "Network error or server unreachable",
      };
    }
  }

  static async ResetPassword(loginRequest) {
    try {
      const loginUrl = API_ENDPOINTS.setPasswordReset();
      const response = await axios.post(loginUrl, loginRequest, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      console.error("Error occurred during login:", error);

      // Return a consistent error object to handle in caller
      return {
        statusCode: "500",
        error: error.code || "UNKNOWN_ERROR",
        message: "Network error or server unreachable",
      };
    }
  }
}
export default LoginService